import { getContractWithABI, } from "@bracket/chainography";
import { getViemClients, } from "@bracket/contractor-next";
import type { EthereumAddress, } from "@bracket/types";
import { wagmiConfig as config, } from "@wagmiconfig";
import { assertAllowance, } from "./assertAllowance";
import type { ContractResult, } from "./shared";



export declare type WrapProps = {
	vault: EthereumAddress;
	wrapper: EthereumAddress;
	amount: bigint;
}



export const wrap = async ({
	vault,
	wrapper,
	amount,
}: WrapProps): Promise<ContractResult> => {

	try {

		const [ reader, writer, ] = await getViemClients({ config, });
		await assertAllowance({ spender: wrapper, token: vault, amount, });
		const [ _, abi ] = getContractWithABI("BracketWrappedVault", 1);
		const { request, } = await reader.simulateContract({
			address: wrapper,
			abi,
			functionName: "wrap",
			args: [
				amount,
			],
			account: writer.account,
		});
		const hash = await writer.writeContract(request);
		await reader.waitForTransactionReceipt({ hash, });
		return {
			success: true,
			hash,
		};

	}
	catch(err) {

		if(err?.cause?.cause?.code === 4001) {
			return {
				success: false,
				canceled: true,
			}
		}

		return {
			success: false,
			error: err as Error,
		};

	}


}
